import { useMantineTheme } from '@mantine/core';

import { IconMarketplaceCrossLock } from '~/domains/design-system/icons/IconMarketplaceCrossLock';
import { IconMarketplaceLock } from '~/domains/design-system/icons/IconMarketplaceLock';

const PICK_CONTROL_ICON_SIZE = 16;

function PickControlIndicator({
  isPickController,
  tone = 'subtle',
}: {
  isPickController: boolean;
  tone?: 'subtle' | 'strong';
}) {
  const theme = useMantineTheme();

  if (!isPickController) {
    return (
      <IconMarketplaceCrossLock
        size={PICK_CONTROL_ICON_SIZE}
        color={tone === 'strong' ? theme.colors.gray2[3] : theme.colors.gray2[2]}
        slashOutlineColor={theme.white}
      />
    );
  }

  return <IconMarketplaceLock size={PICK_CONTROL_ICON_SIZE} color={theme.colors.green[6]} />;
}

export default PickControlIndicator;
